import { useState, useEffect } from "react";
import eatful from'../../assets/home/eatful-logo.png'
import { Link } from "react-router-dom";
// import { useState } from "react";
import axios from "axios";
const Footer = () => {
    const [year, setYear] = useState("");

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        setYear(currentYear);
    }, []);

    const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
        const res = await axios.post(
        "https://eatful.in/email/newsletter.php",
        { type: "subscribe", email },
        { headers: { "Content-Type": "application/json" } }
        );

        if (res.data.success) {
        setMsg("Subscribed successfully ✅");
        setEmail("");
        } else {
        setMsg("Subscription failed ❌");
        }
    } catch (err) {
        console.error(err);
        setMsg("Server error ❌");
    }

    setTimeout(() => setMsg(""), 2000);
  };

    return (
        <>
            <div className="container-fluid" style={{
                background:'white'
            }}>
                <div className="row pt-5 pb-5">
                    <div className="col-md-3">

                        <img src={eatful} style={{
                            width:'80px',
                            height:'60px'
                        }} alt="earful"/>

                        <p style={{
                            color:'black',
                            textAlign:'center'
                            
                        }}>
                            Addiction isn’t always dangerous.
                            We make guilt-free snacks so delicious, they feel addictive —
                            the kind of kick you’ll love.
                        </p>
                    </div>

                    <div className="col-md-3 text-center">
                        <ul style={{
                            listStyle:'none',
                            color:'black',
                        }}>
                            <li>
                                <Link to="/" style={
                                    {
                                    color:'black',
                                    textDecoration:'none',
                                    }
                                    }>
                                    Home
                                </Link>                                
                            </li>
                            <li>
                                <Link to="/about" style={
                                    {
                                    color:'black',
                                    textDecoration:'none',
                                    }
                                    }>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/store" style={
                                    {
                                    color:'black',
                                    textDecoration:'none',
                                    }
                                    }>
                                    Store
                                </Link>
                               
                            </li>
                            <li>
                                <Link to="/contact" style={
                                {
                                    color:'black',
                                    textDecoration:'none'
                                }
                                }>
                                Gifting
                                </Link>
                            </li>
                            <li>
                                <Link to="/deletion" style={
                                {
                                    color:'black',
                                    textDecoration:'none'
                                }
                                }>
                                Data Deletion Request
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-3 text-center">
                        <ul style={{
                            listStyle:'none',
                            color:'black',
                        }}>
                            <li>
                                <Link to="/privacy-policy" style={
                                    {
                                        color:'black',
                                        textDecoration:'none'
                                    }
                                    }>
                                        Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/refund-policy" style={
                                    {
                                        color:'black',
                                        textDecoration:'none'
                                    }
                                    }>
                                        Refund Policy
                                </Link>
                            </li>
                            <li>
                               <Link to="/terms-conditions" style={
                                    {
                                        color:'black',
                                        textDecoration:'none'
                                    }
                                    }>
                                        Terms & Conditions
                                </Link>
                            </li>
                            <li>
                               <Link to="/shipping-policy" style={
                                    {
                                        color:'black',
                                        textDecoration:'none'
                                    }
                                    }>
                                        Shipping Policy
                                </Link>
                            </li>
                            
                        </ul>
                    </div>

                    <div className="col-md-3  text-center">
                        <form>
                            <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Newsletter"
                                required
                                className="w-100 p-2"
                                style={{
                                borderRadius: "10px",
                                background: "transparent",
                                border: "1px solid black",
                                boxShadow: "6px 5px black",
                                color:'black'
                                }}
                            />

                           <button
                            type="submit"
                            onClick={handleSubmit}
                            style={{
                                width: "100%",
                                marginTop: "10px",
                                borderRadius: "10px",
                                background: "transparent",
                                border: "1px solid black",
                                boxShadow: "6px 5px black",
                                color: "black",
                                padding: "5px",
                                fontWeight: "700"
                            }}
                            >
                            SUBSCRIBE
                            </button>



                            {msg && <p className="text-center mt-2 fw-bold">{msg}</p>}
                        </form>                    
                    </div>
               
                </div>

                <div className="d-flex justify-content-between align-items-center pb-3">
                    <h6 style={{
                        fontWeight:'600',
                        color:'black'
                    }}>
                        <span>{year}</span>, EatFul. Powered By EATFUL
                    </h6>

                    <div>
                        <ul style={{
                            listStyle:'none',
                            float:'right',
                            display:'flex',
                            gap:'10px'
                        }}>
                            {/* <li>
                                <i class="bi bi-facebook text-dark" style={{
                                    cursor:'pointer',}}><a href="https://www.instagram.com/eatful.in/"></a></i>
                            </li> */}
                            <li>
                            <a 
                                href="https://www.instagram.com/eatful.in/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ cursor: "pointer" }}
                            >
                                <i className="bi bi-instagram text-dark"></i>
                            </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Footer;
